// eslint-disable-next-line no-unused-vars
var SKYKICK_BLUE = "#00acff";
var DARKER_SKYKICK_BLUE = "#137CBD";
var DARK_NAVY_BLUE = "#001529";
var NICE_GREEN_BROWN = "#254b42";
var MUSTARD = "#F2B824";

var COLORS = {
  primary: DARKER_SKYKICK_BLUE,
  secondary: DARK_NAVY_BLUE,
  //
  skykick_blue: SKYKICK_BLUE,
  darker_skykick_blue: DARKER_SKYKICK_BLUE,
  dark_navy_blue: DARK_NAVY_BLUE,
  nice_green_brown: NICE_GREEN_BROWN,
  mustard: MUSTARD,
};

module.exports = COLORS;
